module.exports = __webpack_public_path__ + "static/media/slide4.51b184e9.png";